var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 3 23 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.912,
    y: 7.185,
    width: 6.303,
    height: 15.297,
    rx: 3.151,
    transform: "rotate(40.075 12.912 7.185)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.724 6.221a5.456 5.456 0 1 1 8.35 7.026l-8.802 10.462a5.456 5.456 0 1 1-8.35-7.026l8.802-10.462z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
export default SvgAttach;